(function () {
  'use strict';
  class ChuppsCardCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-photo-track]');
      this.previous = this.querySelector('[data-carousel-prev]');
      this.next = this.querySelector('[data-carousel-next]');
      if (!this.track) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const update = () => {
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const position = rtl ? -this.track.scrollLeft : this.track.scrollLeft;
        this.previous.disabled = position < 2;
        this.next.disabled = position + this.track.clientWidth >= this.track.scrollWidth - 2;
      };
      const move = (direction) => {
        const card = this.track.querySelector('.chupps-photo-card');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const distance = (card?.getBoundingClientRect().width || this.track.clientWidth) + gap;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.scrollBy({ left: direction * distance * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      this.previous.addEventListener('click', () => move(-1), { signal });
      this.next.addEventListener('click', () => move(1), { signal });
      this.track.addEventListener('scroll', update, { passive: true, signal });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      }, { signal });
      this.resize = new ResizeObserver(update);
      this.resize.observe(this.track);
      update();
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
  }
  if (!customElements.get('chupps-card-carousel')) customElements.define('chupps-card-carousel', ChuppsCardCarousel);
})();
